import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import ReportECGComponent from "../../../components/ecg-report-component";

import { useLocation, useNavigate } from "react-router-dom";

import LoginPage from "../login-page";
import LoginStatus from "../../../authentication/login-status";

import { modal_mode_halfscreen } from "../../../redux/actions/actionConstants";

import prepareConclusionService from "../../../services/ConclusionConstructor/prepareConclusionService.ts";
import prepareDataService from "../../../services/prepareDataServices";
import prepareSignalService from "../../../services/prepareSignalService";
import { ReportDataProvider } from "../../../services/report-data-service-provider";
import getUrls from "../../../api";
import { ErrorIndicator, ErrorSimple } from "../../../components//state-indicators";
import { Spinner } from "../../../components//state-indicators";
import compose from "../../../utils/compose";
import setTheme from "../../../utils/setTheme.js";
import withLocalization from "../../../hoc/with-localization";
import CloseBtn from "../../../components/close-btn/index.js";

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const ReportPage = props => {
    // Query params
    let query = useQuery();
    const res = query.get("res"),
        user_sam = query.get("resUser"),
        user_storage_name = query.get("resStorageName"),
        user_source = query.get("sourceUser"),
        session_id = query.get("hotbox_session") || query.get("session_id"),
        record = query.get("record"),
        storageName = query.get("storageName"),
        patientId = query.get("patientId");

    /** EXTERN PROPERTIES
     * @param {string} res - analysis result ID
     * @param {string} user_sam - optional parameter - sam name of data owner (if open data of another user)
     * @param {string} user_storage_name - optional parameter - storagename of data owner (if open data of another user)
     * @param {string} user_source - id отправителья записи (для определения департамента)
     *
     * @param {string} session_id - идентификатор сессии работы с HotBox
     * @param {string} record -  Название записи для box51
     *
     * @param {string} storageName - Storage name to get user directory
     * @param {string} patientId - Patient ID to get patient info
     */

    const navigate = useNavigate();
    const dataService = useRef();
    const signalService = useRef();
    const conclusionService = useRef();
    useEffect(() => {
        if (!res && !session_id && !record) {
            navigate("/");
        }

        const prepare = async () => {
            const { basepath, anonymousMode } = props;
            dataService.current = prepareDataService(basepath);
            signalService.current = prepareSignalService(basepath);
            conclusionService.current = prepareConclusionService(basepath, anonymousMode);

            await fetchSettings()
                .then(setts => {
                    const { webLauncherUrl, reportConstructorAPIurl } = setts?.conclusionConstructor ?? {};
                    const { SACR_config: _SACR } = setts ?? {};

                    setSACR_config(_SACR);

                    // Data service
                    dataService.current.setIDs({
                        res,
                        user_sam,
                        user_storage_name,
                        user_source,
                        session_id,
                        storageName,
                        patientId,
                        record
                    });
                    dataService.current.bearerToken = user?.access_token;

                    // Signal service
                    var user_name = user_sam || user?.profile?.name;
                    signalService.current.setIDs(res, user_name, user_source, storageName, record, session_id);
                    signalService.current.bearerToken = user?.access_token;

                    // Conclusion service
                    const mode_CoreKernel = !anonymousMode;
                    if (mode_CoreKernel) {
                        conclusionService.current.SetSettings?.({ webLauncherUrl, reportConstructorAPIurl });
                    }
                })
                .catch(err => {
                    console.error(err); // eslint-disable-line
                    setErrorSetts(true);
                })
                .finally(() => {
                    setLoadingSetts(false);
                });
        };
        prepare();
    }, []); // eslint-disable-line

    const [loadingSetts, setLoadingSetts] = useState(true);
    const [errorSetts, setErrorSetts] = useState(false);
    const [SACR_config, setSACR_config] = useState();

    const { user, theme, printMode = false, halfScreenModalOpened, loading, anonymousMode, basepath, loc, useCloseAppFile } = props;

    async function fetchSettings() {
        return fetch(getUrls(basepath).urlGetSettings).then(resp => {
            if (!resp.ok) throw Error("Error! Fetch settings request status is not Ok!");
            return resp.json();
        });
    }

    // Check user
    const needAuth = !(anonymousMode || printMode);
    if (needAuth && (!user || user.expired)) {
        return <LoginPage {...{ anonymousMode }} />;
    }

    const ErrorComp = <ErrorSimple loc={loc} text={loc("errors.fetchSettings")} />;
    setTheme(theme);

    const AppCloseBtn =
        SACR_config || (anonymousMode && useCloseAppFile) ? (
            <CloseBtn {...{ basepath, anonymousMode, useCloseAppFile, SACR_config, loc }} />
        ) : null;
    return (
        <div>
            <ReportDataProvider
                value={{
                    dataService: dataService.current,
                    signalService: signalService.current,
                    conclusionService: conclusionService.current
                }}>
                {errorSetts ? (
                    <ErrorIndicator withCaption descriptionComponent={ErrorComp} />
                ) : loadingSetts ? (
                    <Spinner withCaption />
                ) : (
                    <ReportECGComponent
                        {...{
                            res,
                            user_sam,
                            user_storage_name,
                            user_source,
                            session_id,
                            storageName,
                            patientId,
                            record,
                            SACR_config,
                            dataService: dataService.current,
                            signalService: signalService.current,
                            conclusionService: conclusionService.current,
                            anonymousMode,
                            AppCloseBtn,
                            Login: !halfScreenModalOpened && <LoginStatus loading={loading} />
                        }}
                    />
                )}
            </ReportDataProvider>
        </div>
    );
};
const mapStateToProps = state => {
    const {
        oidc,
        reportApp: {
            app: { settings, modal, loadState }
        }
    } = state;
    return {
        user: oidc.user,
        lang: settings.lang,
        theme: settings.theme,

        halfScreenModalOpened: modal.opened && modal.dialogMode === modal_mode_halfscreen,

        loading: loadState.loading,
        error: loadState.error
    };
};

export default compose(withLocalization, connect(mapStateToProps))(ReportPage);
